import { render } from "./talleres.vue?vue&type=template&id=53b50b96"
import script from "./talleres.vue?vue&type=script&lang=js"
export * from "./talleres.vue?vue&type=script&lang=js"
script.render = render

export default script